// ** react imports
import { useEffect, useState } from 'react';

// ** redux imports
import { useDispatch } from 'react-redux';
import { setToken, setUserDetails } from '../../redux/slices/users';

// ** router imports
import { Navigate, useLocation } from 'react-router-dom';

// ** util imports
import SessionStorage from '../../utils/SessionStorage';

// ** enums imports
import { USER_ROLES } from '../../enums/common';

const ProtectedRoute = ({ children }) => {
  // vars
  const token = SessionStorage.get('token');
  const users = JSON.parse(SessionStorage.get('users') || '{}');

  // hooks
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    if (token && Object.keys(users).length > 0) {
      dispatch(setToken(token));
      dispatch(setUserDetails(users));
    }
  }, [token, users]);

  if (!token || Object.keys(users).length === 0) {
    return <Navigate to="/auth/signin" state={{ from: location }} replace />;
  } else {
    return children;
  }
};

export const AdminProtectedRoute = ({ children }) => {
  // states
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // vars
  const token = SessionStorage.get('token');
  const users = JSON.parse(SessionStorage.get('users') || '{}');

  // hooks
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    if (token && Object.keys(users).length > 0) {
      setIsAuthenticated(true);
      dispatch(setToken(token));
      dispatch(setUserDetails(users));
    }
  }, [token, users]);

  if (!token && !isAuthenticated) {
    return <Navigate to="/auth/signin" state={{ from: location }} replace />;
  } else if (users.role !== USER_ROLES.ADMIN) {
    return (
      <Navigate to="/error/unauthorized" state={{ from: location }} replace />
    );
  } else {
    return children;
  }
};

export default ProtectedRoute;
